/* eslint-disable max-lines-per-function */
import type { Token } from '../../core/token';

export default (): Partial<Token> => ({
  dvStandardChart: {
    baseOption: {
      legend: {
        backgroundColor: '#181e25',
        textStyle: {
          fontSize: 12,
          lineHeight: 16,
          color: '#FAFBFC',
          dvDisabledTextColor: 'rgba(250,251,252,0.2)'
        },
        dvPagination: {
          color: '#FAFBFC',
          image: `url('data:image/svg+xml;base64,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')`,
          imageHover: `url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+57yW57uEIDY8L3RpdGxlPgogICAgPGcgaWQ9Iue7hOS7tuinhOWImeesrOS6jOeJiCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjAyLuaXtumXtOi9tOe7hOS7tuminOiJsuaYoOWwhOihqOWkh+S7vSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI1NC4wMDAwMDAsIC0xNTc2LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0i57yW57uELTY45aSH5Lu9LTEzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMi4wMDAwMDAsIDE1MjIuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0i57yW57uEIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgNDguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC04IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMC4wMDAwMDAsIDAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSLnvJbnu4QtNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjEyLjAwMDAwMCwgNi4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJ0cmFuc3BhcmVudC1yZWN0YW5nbGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguMDAwMDAwLCA4LjAwMDAwMCkgcm90YXRlKC00NTAuMDAwMDAwKSB0cmFuc2xhdGUoLTguMDAwMDAwLCAtOC4wMDAwMDApICIgcG9pbnRzPSIwIDkuNzk3MTc0MzllLTE2IDE2IDkuNzk3MTc0MzllLTE2IDE2IDE2IDAgMTYiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zLjI0NDA3NzY4LDUuMjUxMDUxMzMgQzMuNTQ0NDgwOTgsNC45NDIwNjUwOCA0LjAxNzE3MzUzLDQuOTE4Mjk2OSA0LjM0NDA4Mjg3LDUuMTc5NzQ2ODEgTDQuNDIyNTg4OTgsNS4yNTEwNTEzMyBMOCw4LjkzIEwxMS41Nzc0MTEsNS4yNTEwNTEzMyBDMTEuODc3ODE0Myw0Ljk0MjA2NTA4IDEyLjM1MDUwNjksNC45MTgyOTY5IDEyLjY3NzQxNjIsNS4xNzk3NDY4MSBMMTIuNzU1OTIyMyw1LjI1MTA1MTMzIEMxMy4wNTYzMjU2LDUuNTYwMDM3NTggMTMuMDc5NDMzNiw2LjA0NjIzNTYzIDEyLjgyNTI0NjIsNi4zODI0ODUyNCBMMTIuNzU1OTIyMyw2LjQ2MzIzNDM4IEw4LjU4OTI1NTY1LDEwLjc0ODk0ODcgQzguMjg4ODUyMzUsMTEuMDU3OTM0OSA3LjgxNjE1OTgsMTEuMDgxNzAzMSA3LjQ4OTI1MDQ2LDEwLjgyMDI1MzIgTDcuNDEwNzQ0MzUsMTAuNzQ4OTQ4NyBMMy4yNDQwNzc2OCw2LjQ2MzIzNDM4IEMyLjkxODY0MDc3LDYuMTI4NDk5MjggMi45MTg2NDA3Nyw1LjU4NTc4NjQ0IDMuMjQ0MDc3NjgsNS4yNTEwNTEzMyBaIiBpZD0i6Lev5b6ELTMiIGZpbGw9IiM3RThERkYiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=')`,
          imageDisabled: `url('data:image/svg+xml;base64,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')`
        }
      },
      dataZoom: [
        {
          type: 'slider',
          show: false,
          moveOnMouseMove: false,
          zoomOnMouseWheel: false,
          backgroundColor: '#313438',
          fillerColor: '#DADDE0',
          borderColor: '#60656C',
          handleIcon:
            'image://data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8cmVjdCB4PSI0IiB3aWR0aD0iOCIgaGVpZ2h0PSIxNiIgcng9IjEiIGZpbGw9IiMxQTlGRkYiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYgNS41QzYgNS4yMjM4NiA2LjIyMzg2IDUgNi41IDVIOS41QzkuNzc2MTQgNSAxMCA1LjIyMzg2IDEwIDUuNUMxMCA1Ljc3NjE0IDkuNzc2MTQgNiA5LjUgNkg2LjVDNi4yMjM4NiA2IDYgNS43NzYxNCA2IDUuNVpNNiA4QzYgNy43MjM4NiA2LjIyMzg2IDcuNSA2LjUgNy41SDkuNUM5Ljc3NjE0IDcuNSAxMCA3LjcyMzg2IDEwIDhDMTAgOC4yNzYxNCA5Ljc3NjE0IDguNSA5LjUgOC41SDYuNUM2LjIyMzg2IDguNSA2IDguMjc2MTQgNiA4Wk02LjUgMTBDNi4yMjM4NiAxMCA2IDEwLjIyMzkgNiAxMC41QzYgMTAuNzc2MSA2LjIyMzg2IDExIDYuNSAxMUg5LjVDOS43NzYxNCAxMSAxMCAxMC43NzYxIDEwIDEwLjVDMTAgMTAuMjIzOSA5Ljc3NjE0IDEwIDkuNSAxMEg2LjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4='
        }
      ],
      series: [
        {
          type: 'wordCloud',
          dvTextColors: [
            '#FAFBFC',
            '#E9EDF6',
            '#E0E4EA',
            '#828FA1',
            '#545E71',
            '#545E71',
            '#545E71'
          ]
        }
      ]
    }
  },
  dvHXKLine: {
    theme: 'dark'
  },

  // * --- echarts theme  @see https://echarts.apache.org/zh/theme-builder.html
  backgroundColor: '#181e25',
  titleColor: '#fafbfc',
  axes: [
    {
      type: 'all',
      name: '通用坐标轴',
      axisLineShow: true,
      axisLineColor: '#92989f',
      axisTickShow: false,
      axisTickColor: '#484c51',
      axisLabelShow: true,
      axisLabelColor: '#92989f',
      splitLineShow: true,
      splitLineColor: ['#484c51'],
      splitAreaShow: false,
      splitAreaColor: ['#eeeeee']
    },
    {
      type: 'category',
      name: '类目坐标轴',
      axisLineShow: true,
      axisLineColor: '#333',
      axisTickShow: true,
      axisTickColor: '#333',
      axisLabelShow: true,
      axisLabelColor: '#333',
      splitLineShow: false,
      splitLineColor: ['#ccc'],
      splitAreaShow: false,
      splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
    },
    {
      type: 'value',
      name: '数值坐标轴',
      axisLineShow: true,
      axisLineColor: '#333',
      axisTickShow: true,
      axisTickColor: '#333',
      axisLabelShow: true,
      axisLabelColor: '#333',
      splitLineShow: true,
      splitLineColor: ['#ccc'],
      splitAreaShow: false,
      splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
    },
    {
      type: 'log',
      name: '对数坐标轴',
      axisLineShow: true,
      axisLineColor: '#333',
      axisTickShow: true,
      axisTickColor: '#333',
      axisLabelShow: true,
      axisLabelColor: '#333',
      splitLineShow: true,
      splitLineColor: ['#ccc'],
      splitAreaShow: false,
      splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
    },
    {
      type: 'time',
      name: '时间坐标轴',
      axisLineShow: true,
      axisLineColor: '#333',
      axisTickShow: true,
      axisTickColor: '#333',
      axisLabelShow: true,
      axisLabelColor: '#333',
      splitLineShow: true,
      splitLineColor: ['#ccc'],
      splitAreaShow: false,
      splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
    }
  ],

  // * --- UED Token -----------------------------------------------------------------------------------
  '--color-background-weak': 'rgba(255,255,255,0.06)',

  '--color-visualization-divider': 'rgba(0,0,0,0.06)',
  '--color-visualization-tooltip': '#ffffff',

  '--color-text-primary': 'rgba(255,255,255,0.84)',
  '--color-text-secondary': 'rgba(255,255,255,0.6)',
  '--color-text-tertiary': 'rgba(255,255,255,0.4)',
  '--color-text-quaternary': 'rgba(255,255,255,0.24)',
  '--color-text-inverse': '#ffffff',
  '--color-text-link': '#4167d9',

  '--color-grey-01': '#292929',
  '--color-grey-02': '#212121',
  '--color-grey-03': '#3b3b3b',
  '--color-grey-04': '#6e6e6e',
  '--color-grey-05': '#858585'
});
